<template lang="pug">
.wrapper
    .px-4
        HeaderGlobal(HeaderGlobalHeading="Users Log" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading Users Log
            .box__body
                .form.p-4(v-if="users_log.data && users_log.data.length > 0")
                    .flex.flex-wrap.items-center.justify-between
                        .field.mr-3.relative
                        //- JsonExcel.btn.btn-primary.cursor-pointer(
                        //-     type = "csv"
                        //-     :title="['Log Users ', from_date + ' - ' + to_date]"
                        //-     :name="csvName"
                        //-     :data="csvData"
                        //- )
                        //-     | Download CSV

                .form.p-4
                    .flex.flex-wrap.items-center.justify-between
                        .flex.flex-wrap.items-center
                            .relative.mr-3.field-date-time-picker
                                date-range-picker(
                                    v-if="dateRange.startDate && dateRange.endDate" 
                                    ref="picker" 
                                    v-model="dateRange" 
                                    @update="pickerUpdate($event,'list')" 
                                    :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }" 
                                    :date-format="dateFormat" 
                                    opens="right" 
                                    :ranges="default_ranges"
                                    autoApply=true)
                                    div(
                                        slot="input" 
                                        slot-scope="picker") 
                                            | {{ picker.startDate | date}} - {{ picker.endDate  | date}}

                                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>

                            //- .field.relative.field--search.mr-3
                                .relative
                                    input.field-style#find-user-input(type="text" placeholder="Search user (write min 3 characters)" v-model="user_keyword" @keyup="searchUser()")
                                    .absolute.inset-y-0.right-0.flex.items-center.px-2
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>

                                .search-result(style="position: absolute; background: #021827; width: 100%;max-height: 300px;overflow: auto;")
                                    //- .search-result
                                    .flex.flex-wrap.items-center.justify-center.p-2(v-if="load_data_status_users_list === 'loading'")
                                        Spinner(show="true" size="48")
                                    ul(v-else-if="users_list.data && users_list.data.length > 0" id="autocomplete-list" )
                                        li.flex.items-center.justify-between.border-b.border-gray-200.p-4(
                                            class="hover:bg-gray-100"
                                            style="cursor: pointer;"
                                            v-for="(user,index) in users_list.data"
                                            :key="user.id"
                                            @click="selectUser(user)"
                                        )
                                            .flex.items-center
                                                span.text-gray-600.name-index {{ user.name }}
                                                    

                                    .flex.flex-wrap.items-center.justify-center.p-2(v-else-if="users_list.data && users_list.data.length == 0")
                                        | No data available.
                                
                            .flex.items-center(class="-mx-1")
                                .w-full.px-1(class="md:w-1/2")
                                    button.btn-default(type="button" @click="resetList()") Reset
                                .w-full.px-1(class="md:w-1/2")
                                    button.btn-primary-o(type="button" @click="filterList()") Apply
                        .flex.flex-wrap.items-center
                            .flex.flex-wrap.items-center
                                span.mr-2 Show
                                .field.mr-2.relative
                                    select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
                                        option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                                    .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                span entries

                .table-static.w-full.py-4
                    table.table-general
                        thead
                            tr
                                th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                        tbody
                            tr(v-if="load_data_status_users_log === 'loading'")
                                td.text-center(:colspan="tableThead.length")
                                    .flex.flex-wrap.items-center.justify-center
                                        Spinner(show="true" size="48")
                            template(v-else-if="users_log.data && users_log.data.length > 0")
                                tr(v-for="(log,index) in users_log.data" :key="index")
                                    td 
                                        .grid
                                            span {{ log.user && log.user.name?log.user.name : getName(log) }} 
                                            span {{ log.email?log.email:'-' }}
                                    //- td {{ log.email?log.email:'-' }}
                                    td 
                                        template(v-if="log.function === 'login'")
                                            small.inline-block.bg-green-200.rounded.py-1.px-2.text-green-600.uppercase.text-center.font-bold(style="min-width:85px") Login
                                        template(v-else)
                                            small.inline-block.bg-red-200.rounded.py-1.px-2.text-red-600.uppercase.text-center.font-bold(style="min-width:85px") Logout
                                    td {{ log.created_at?log.created_at:'-' }}
                                    //- td 
                                        small {{ log.response.code?log.response.code:'-' }}
                                    td
                                        template(v-if="log.response.code === 200 || log.response.code === 201")
                                            small.inline-block.bg-green-200.rounded.py-1.px-2.text-green-600.uppercase.text-center.font-bold(style="min-width:85px") Success
                                        template(v-else)
                                            small.inline-block.bg-red-200.rounded.py-1.px-2.text-red-600.uppercase.text-center.font-bold(style="min-width:85px") Failed
                                    //- td 
                                    //-     small {{ log.type?log.type:'-' }}
                                    //- //- td 
                                    //-     small {{ log.size?log.size:'-' }}
                                    //- td 
                                    //-     small {{ log.from_date?log.from_date:'-' }}
                                    //- td 
                                    //-     small {{ log.to_date?log.to_date:'-' }}
                                    //- //- td 
                                    //-     small {{ log.function?log.function:'-' }}
                                    //- //- td 
                                    //-     small {{ log.module?log.module:'-' }}
                                    //- td 
                                    //-     small {{ log.function?getModule(log.function):'-' }}
                                    //- //- td 
                                    //-     small {{ log.path_url?log.path_url:'-' }}
                                    //- td 
                                    //-     small {{ log.created_at.split('+')[0] }}
                                    //- td 
                                    //-     small {{ log.browser?log.browser:'-' }}
                                    //- td 
                                    //-     small {{ log.os?log.os:'-' }}
                                    //- td 
                                    //-     small {{ log.ip?log.ip:'-' }}
                                    //- td
                                    //-     template(v-if="log.response.code === 200 || log.response.code === 201")
                                    //-         small.inline-block.bg-green-200.rounded.py-1.px-2.text-green-600.uppercase.text-center.font-bold(style="min-width:85px") Success
                                    //-     template(v-else)
                                    //-         small.inline-block.bg-red-200.rounded.py-1.px-2.text-red-600.uppercase.text-center.font-bold(style="min-width:85px") Failed
                                    //-     //- | Code: 
                                    //-     //- span(v-if="log.response.code === 200" style="color: #19d78c;")
                                    //-     //-     | {{ log.response.code }}
                                    //-     //- span.field--error(v-else)
                                    //-     //-     | {{ log.response.code }}
                                    //-     //- br
                                    //-     //- | Message: {{ log.response.message }}
                                    //- td 
                                    //-     small {{ log.user?log.user.name:'-' }}
                                    //- //- td.action
                                    //-     button.btn-small.btn-default(v-tooltip="'Show Response'" @click="getResponse(true, log.response)")
                                    //-         div.text-gray-500
                                    //-             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-code"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>
                            tr(v-else)
                                td.text-center(:colspan="tableThead.length") No Data Available
                    .mt-5
                    vue-ads-pagination(
                        :total-items="total_data"
                        :items-per-page="items_per_page"
                        :page="page"
                        :max-visible-pages="5"
                    )
                        template(slot="buttons" slot-scope="props")
                            vue-ads-page-button(
                                v-for="(button, key) in props.buttons"
                                :key="key"
                                v-bind="button"
                                :class="{'bg-yellow-dark': button.active}"
                                @page-change="page = button.page"
                                @range-change="start = button.start; end = button.end"
                            )
    //- pop up notes
    section.section-popup.fixed.w-full-h.full.bg-gray-100.inset-0.flex.items-start.justify-center(
        v-bind:class="{'section-popup--show' : openResponse}"
    )
        .section-popup__container
            .box
                .box__header.no-border
                    header.flex.items-center.justify-between
                        span.text-gray-600 Response
                        .header-cta
                            button.btn-icon.btn-default(@click="getResponse(false)")
                                div.text-gray-500
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                .box__body.p-4
                    .pb-2
                        strong Code: {{tmpLogCode}}
                    .pb-2
                        vue-json-pretty(:data="tmpLogMessage")

</template>

<script>

import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue'
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
import JsonCSV from 'vue-json-csv';
import JsonExcel from "vue-json-excel";
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import VueJsonPretty from 'vue-json-pretty'
// import 'vue-json-pretty/styles.css'
import 'vue-json-pretty/lib/styles.css'
import { decryptAPI } from '@/util/crypto';

export default {
    name: 'PageUsersLog',
    components: {
        HeaderGlobal,
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
        DateRangePicker,
        JsonCSV,
        JsonExcel,
        Loading,
        NoDataAvailable,
        VueJsonPretty,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Users Log',
                    url: '/users-log',
                },
            ],
            // advanceFilter: false,
            filterUser: '',
            optFilterUser: [],

            from_date: '',
            to_date: '',
            dateRange: {
                startDate: '',
                endDate: '',
            },
            default_ranges: {
                'Today': [moment().toDate(), moment().toDate()],
                'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
                // 'This month': [moment().startOf('month'), moment().endOf('month')],
                // 'This year': [moment().startOf('year'), moment().endOf('year')],
                'Last 7 days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
                // 'Last week': [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
                // 'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            },

            tableThead: [
                {
                    name: 'Name',
                },
                // {
                //     name: 'Email',
                // },
                {
                    name: 'Activity',
                },{
                    name: 'Datetime',
                }
                ,{
                    name: 'Status',
                }
            ],
            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            keyword: '',
            timeout: null,

            user_keyword:'',
            user_id:null,

            csvName: 'log_monitoring'+moment().format('YYYY-MM-DD_HH:mm:ss')+'.csv',
            csvData: [],
            
            openResponse: false,
            tmpLogCode:null,
            tmpLogMessage:null,

            isAstro: process.env.VUE_APP_ASTRO,
        }
    },
    computed: {
        ...mapState([
            'load_data_status_users_log',
            'users_log',
            'load_data_status_users_list',
            'users_list',
        ]),
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        route_name(newData, oldData) {
            // if (newData === 'PageUsersLog') {
            //     this.getData();
            // }

            if (newData === 'PageUsersLog') {
                if (oldData !== 'PageUsersLog') {
                    this.items_per_page = 10;
                    this.page = 0;
                    this.keyword = '';
                    this.$store.commit('setUsersDetail', {});
                    this.$store.commit('setUsersLog', {});
                }

                this.getData(true);
            }
        },
        users_log(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            }
            if (newData.data && newData.data.length > 0) {
                this.getDataCsv(newData.data)
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        keyword() {},
        user_keyword(newData) {
            if (newData.length < 3)
                this.$store.commit('setUsersList', {});
        },
        // user_id(newData) {
        //     if (newData != null)
        //         this.getData()
        // },
    },
    methods: {
        getData() {
            this.$store.commit('setUsersList', {});
            // for dispatch get data
            this.$store.dispatch('getUsersLog', [this.user_id, this.items_per_page, (this.page + 1), this.keyword, this.from_date, this.to_date]);

            if (this.users_log.data && this.users_log.data.length > 0) {
                this.getDataCsv(this.users_log.data)
            // console.log(this.users_log.total_page)
            }
            this.pagination();
        },
        getDataCsv(data) {
            this.csvData = data.map((item) => {
                return {
                    key: item.key?item.key:'-',
                    type: item.type?item.type:'-',
                    // size: item.size?item.size:'-',
                    from_date: item.from_date?item.from_date:'-',
                    to_date: item.to_date?item.to_date:'-',
                    // function: item.function?item.function:'-',
                    // module: item.module?item.module:'-',
                    module: item.function?this.getModule(item.function):'-',
                    // path_url: item.path_url?item.path_url:'-',
                    searched_on: item.created_at?item.created_at.split('+')[0]:'-',
                    browser: item.browser?item.browser:'-',
                    platform: item.os?item.os:'-',
                    ip: item.ip?item.ip:'-',
                    status: (item.response.code === 200 || item.response.code === 201)?'success':'failed',
                    user: item.user?item.user.name:'-',
                    // log_code: item.response?item.response.code:'-',
                    // log_message: item.response?item.response.message:'-',
                };
            })
        },
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        searchKeyword() {
            // // clear timeout variable
            // clearTimeout(this.timeout);
            
            // var self = this;
            // this.timeout = setTimeout(function () {
            //     // enter this block of code after 1 second
            //     // handle stuff, call search API etc.
            //     self.page = 0;
            //     self.$store.commit('setUsersLog', {});

            //     // if (self.keyword.length > 0) {
            //         self.getData();
            //     // }
            // }, 650);
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null) {
            this.$swal.fire({
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                icon: 'error',
                // timer: 3000
            });
        },
        datetimeFormat(datetime) {
            return moment(datetime, 'YYYY-MM-DDThh:mm:ssZ').format('DD MMM YYYY HH:mm:ssZ');
        },
        /* eslint-disable no-unused-vars */
        dateFormat (classes, date) {
            if (!classes.disabled) {
                // console.log('on dateFormat')
                // console.log(moment(date.getTime())._d)

                // classes.disabled = date.getTime() > new Date();
                classes.disabled = moment(date.getTime()).subtract({ hours: 12})._d > new Date();
                // classes.disabled = date.getTime() < new Date(2022, 5, 25);
                
                // console.log("new Date(2022, 05, 25)")
                // console.log(new Date(2022, 5, 25))
                // console.log("moment(date.getTime()).subtract({ hours: 12})._d")
                // console.log(moment(date.getTime()).subtract({ hours: 12})._d)
            }
            const limitLogAuth = this.$store.getters.getLimitLogAuth;
            
            if (!classes.disabled && limitLogAuth) {
                classes.disabled = date.getTime() < new Date(2022, 5, 25);
            }
            return classes;
        },
        getResponse(open=true, log=null){
            if (open) {
                this.tmpLogCode = log.code?log.code:null
                this.tmpLogMessage = null
                if (log.message) {
                    var msg = log.message
                    msg = msg.replace(/'/g, '"').replace(/None/g, '"None"').replace(/False/g, '"False"').replace(/'/g, '"').replace(/True/g, '"True"')
                    this.tmpLogMessage = JSON.parse(msg)
                }
                this.openResponse = true
            } else {
                this.tmpLogCode = null
                this.tmpLogMessage = null
                this.openResponse = false
            }
        },
        resetList() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset filter?',
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.defaultFilter()
                    this.getData()
                }
            });
        },
        filterList() {
            this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
            this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');
            
            this.getData();
        },
        defaultFilter(){
            const default_date = this.$store.getters.getDefaultDate();

            this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
            this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();
            // this.dateRange.startDate = moment().subtract(6, 'days').toDate()
            // this.dateRange.endDate = moment().toDate();

            this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
            this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

            this.user_keyword=''
            this.user_id=null
        },
        async pickerUpdate(e, type) {
            // console.log('========= DateRangePicker on update')
            // console.log(e)

            let ranges = moment(e.endDate.getTime()).diff(moment(e.startDate.getTime()), 'days') + 1;

            if (this.isAstro !== 'true' && ranges > 7) {
                const default_date = this.$store.getters.getDefaultDate();
                if (type=='list') {

                    this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
                    this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();
        
                    // this.dateRange.startDate = moment().toDate();
                    // this.dateRange.endDate = moment().toDate();

                    this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                    this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');
                } 

                this.$swal.fire({
                    icon: 'error',
                    title: 'Date range is not more than 7 days!',
                    text: 'Your date range is ' + ranges + ' days.',
                    // confirmButtonText: 'Yes!',
                    // confirmButtonColor: '#DD6B55',
                    // showCancelButton: true,
                    // allowOutsideClick: false,
                })

                // return;
            } else {
                if (type=='list') {
                    this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                    this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                    // this.getData();
                }
            }
        },
        searchUser() {
            // clear timeout variable
            clearTimeout(this.timeout);

            var self = this;
            this.timeout = setTimeout(function () {
                if (self.user_keyword.length > 2) {
                    self.$store.commit('setUsersList', {});
                    self.$store.dispatch('getUsersList', [30, 1, self.user_keyword]);
                }
            }, 650);
        },
        selectUser(user){
            this.user_keyword = user.name
            this.user_id = user.id
            this.$store.commit('setUsersList', {});

        },
        getModule(string) {
            let def = ''
            if (string) {
                def= this.titleCase(string)
            }
            else{
                def = '-'
            }
            string = string.toLowerCase()
            switch(string) {
                case 'info-rek':
                    def = 'Bank Account Information';
                    break;
                case 'get-contact':
                    def = 'Get Contact';
                    break;
                case 'kk':
                case 'ktp':
                    def = 'Profile';
                    break;
                case 'recent-location':
                    def = 'Recent Location';
                    break;
                case 'subheader':
                    def = 'Summary Data';
                    break;
                case 'app-usage':
                    def = 'App Usage';
                    break;
                case 'browsing-all':
                    def = 'Browsing Log';
                    break;
                case 'device-history':
                    def = 'Device History';
                    break;
                case 'aerial':
                    def = 'Aerial Log';
                    break;
                    // def = 'Location History';
                    // break;
                case 'detail-location':
                case 'location-history':
                case 'location-log':
                    def = 'Location Log';
                    break;
                case 'tethered-device':
                    def = 'Tethered Device';
                    break;
            }
            return def
        },
        titleCase(string) {
            string = string.replace("-", " ");
            let sentence = string.toLowerCase().split(" ");
            for (let i = 0; i < sentence.length; i++) {
                sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
            }
            
            return sentence.join(" ");
        },
        getName(log){
            var name = "-"
            if (log.response && log.response.message) {
                try {
                    var log2 = log.response.message
                    log2 = log2.replace(/b'/g, "'").replace(/'/g, '"');

                    var { data } = JSON.parse(log2)
                    var decrypted = JSON.parse(decryptAPI(data))
                    name = decrypted.user.name
                } catch (error) {
                    console.log("error")
                    console.log(error)
                }
            }
            return name
            
        }
    },
    mounted() {
        // console.log(this.route_name)
        if (this.route_name === 'PageUsersLog') {
            // reset date filter
            this.defaultFilter()
            this.getData();
        }
    },
    filters: {
        date: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },
    },
}
</script>

<style lang="sass">

</style>


